import api from 'app/AxiosInstance'
import { baseUrl } from 'app/Utils/Config'

const token = localStorage.getItem(`AuthToken`)

export const getAllAccounts = async () => {
  try {
    const {
      data: { data },
    } = await api.get(`${baseUrl}/accounts`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    if (data) {
      return {
        options: data,
      }
    }
  } catch (error) {
    if (error.response) {
      return {
        options: [],
      }
    }
  }
}
